import { Bound } from '@blocksuite/global/gfx';

type CanvasBound = {
  x: number;
  y: number;
  w: number;
  h: number;
};

function isFinitePositive(value: number): boolean {
  return Number.isFinite(value) && value > 0;
}

function isSameBound(a: Bound, b: CanvasBound): boolean {
  return a.x === b.x && a.y === b.y && a.w === b.w && a.h === b.h;
}

export function canPersistAutoMeasuredBound(
  xywh: unknown,
  schemaDefaultBound: CanvasBound
): boolean {
  if (typeof xywh !== 'string') return false;

  try {
    const bound = Bound.deserialize(xywh);
    return (
      Number.isFinite(bound.x) &&
      Number.isFinite(bound.y) &&
      isFinitePositive(bound.w) &&
      isFinitePositive(bound.h) &&
      !isSameBound(bound, schemaDefaultBound)
    );
  } catch {
    return false;
  }
}
